export default __webpack_public_path__ + "static/media/High Priest's Ring of Dexterity.b7332724.jpg";